import BaseComponent from '../../components/base-component/base-component'
import { Nullable } from '../../types/common'

class ShopActiveFilters extends BaseComponent {
  optionsSelector: string
  removeBtnSelector: string

  constructor() {
    super()

    this.optionsSelector = `[data-shop-active-filters-options]`
    this.removeBtnSelector = `[data-shop-active-filters-remove-btn]`
  }

  reset(): void {
    this.replaceChildren()
  }

  setDisable(): void {
    if (this.options) {
      this.options.setAttribute('disabled', '')
    }
  }

  get options(): Nullable<HTMLElement> {
    return this.querySelector(this.optionsSelector)
  }

  get buttons(): Element[] {
    return [...this.querySelectorAll(this.removeBtnSelector)]
  }
}

export default ShopActiveFilters
